import type { AwardStanding } from "@averagejoesff/shared";
import { TeamManagerLabel } from "../../components/TeamManagerLabel";

interface BlowoutSeasonSummaryProps {
  standings: AwardStanding[];
  /** Team name -> manager label to show alongside it (see `useManagerNames`). */
  labelByTeam: Map<string, string>;
}

export function BlowoutSeasonSummary({ standings, labelByTeam }: BlowoutSeasonSummaryProps) {
  if (standings.length === 0) {
    return (
      <p className="blowout-summary__empty">
        No awards handed out yet this season.
      </p>
    );
  }

  return (
    <ol className="blowout-summary">
      {standings.map((row) => (
        <li key={row.teamKey} className="blowout-summary__row">
          <span className="blowout-summary__count">{row.count}</span>
          <span className="blowout-summary__team">
            {row.name}
            <TeamManagerLabel label={labelByTeam.get(row.name)} />
          </span>
          <span className="blowout-summary__weeks">
            {row.weeksWon.map((w) => `Wk ${w}`).join(" · ")}
          </span>
        </li>
      ))}
    </ol>
  );
}
